module.exports = __webpack_public_path__ + "img/img_honor4_us@3x.3f005f1a.png";